module.exports = {
	"id": "sa",
	"name": "South America",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.013028,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.019542,
			"19": null,
			"20": 0.006514,
			"21": 0.006514,
			"22": 0.045598,
			"23": null,
			"24": 0.006514,
			"25": 0.013028,
			"26": 0.03257,
			"27": 0.019542,
			"28": 0.006514,
			"29": 0.019542,
			"30": 0.013028,
			"31": 0.03257,
			"32": 0.019542,
			"33": 0.019542,
			"34": 0.045598,
			"35": 0.039084,
			"36": 0.104224,
			"37": 0.039084,
			"38": 0.052112,
			"39": 0.058626,
			"40": 0.039084,
			"41": 0.039084,
			"42": 0.039084,
			"43": 0.22799,
			"44": 0.09771,
			"45": 0.078168,
			"46": 0.156336,
			"47": 0.149822,
			"48": 0.16285,
			"49": 2.950842,
			"50": 0.22799,
			"51": 0.964072,
			"52": 0.703512,
			"53": 33.475446,
			"54": 9.536496,
			"55": 0.110738,
			"56": 0.026056,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.013028,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": 0.052112,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.013028,
			"13": null,
			"14": null,
			"15": 0.006514,
			"16": 0.006514,
			"17": 0.006514,
			"18": null,
			"19": null,
			"20": 0.006514,
			"21": null,
			"22": null,
			"23": 0.013028,
			"24": 0.006514,
			"25": 0.013028,
			"26": 0.013028,
			"27": 0.052112,
			"28": 0.006514,
			"29": 0.013028,
			"30": 0.013028,
			"31": 0.026056,
			"32": 0.006514,
			"33": 0.026056,
			"34": 0.019542,
			"35": 0.019542,
			"36": 0.013028,
			"37": 0.026056,
			"38": 0.058626,
			"39": 0.03257,
			"40": 0.03257,
			"41": 0.03257,
			"42": 0.026056,
			"43": 0.143308,
			"44": 0.039084,
			"45": 0.123766,
			"46": 0.078168,
			"47": 0.442952,
			"48": 0.35827,
			"49": 4.566314,
			"50": 0.045598,
			"51": 0.006514,
			"52": null,
			"3.5": null,
			"3.6": 0.03257
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.006514,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.026056,
			"37": 0.03257,
			"38": 0.058626,
			"39": 0.013028,
			"40": 0.371298,
			"41": 0.06514,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.013028
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.013028,
			"6": null,
			"7": 0.013028,
			"8": 0.084682,
			"9": 0.09771,
			"10": 0.560204,
			"3.1": null,
			"3.2": null,
			"5.1": 0.019542,
			"6.1": 0.019542,
			"7.1": null,
			"9.1": 0.403868
		},
		"ios_saf": {
			"8": 0,
			"10": 1.82062663114,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0490637810158,
			"8.1-8.4": 0.090643256453,
			"9.0-9.2": 0.0432426544546,
			"9.3": 0.659727676936
		},
		"android": {
			"3": 0,
			"4": 0.0537852868217,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00672316085271,
			"4.1": 0.194011213178,
			"4.2-4.3": 0.485028032946,
			"4.4": 1.11220289535,
			"4.4.3-4.4.4": 1.12180741085
		},
		"ie": {
			"6": 0.0199273352113,
			"7": 0.0199273352113,
			"8": 0.345407143662,
			"9": 0.212558242254,
			"10": 0.172703571831,
			"11": 1.58754437183,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0872665726065,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00242407146129
		},
		"edge": {
			"12": 0.06514,
			"13": 0.247532,
			"14": 0.527634
		},
		"ie_mob": {
			"10": 0.219274309859,
			"11": 0.892759690141
		},
		"bb": {
			"7": 0.038346,
			"10": null
		},
		"samsung": {
			"0": 1.67328
		},
		"and_uc": {
			"0": 0.428778
		},
		"op_mini": {
			"0": 1.17572735593
		},
		"and_chr": {
			"0": 27.308262
		},
		"and_ff": {
			"0": 0.020916
		}
	},
	"total": 98.467964
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/alt-sa.json
 ** module id = 695
 ** module chunks = 0
 **/